import {SERVER_GG_STORE_REPLY} from '../../constans/index';
import {
    GOOGLE_REPLY_DETAIL_REQUEST,
    GOOGLE_REPLY_DETAIL_SUCCESS,
    GOOGLE_REPLY_DETAIL_FAILURE,
} from '../../types/index';
import {RSAA} from 'redux-api-middleware';
import headers from "../../utils/headers";

const GoogleReplyDetailCommentAction = (gameId,reviewId) => ({

    [RSAA]: {
        endpoint: `${SERVER_GG_STORE_REPLY}/api/games/${gameId}/comments/${reviewId}`,
        method: 'GET',
        headers: (headers()),
        types: [
            GOOGLE_REPLY_DETAIL_REQUEST,
            {
                type: GOOGLE_REPLY_DETAIL_SUCCESS,
                payload: async (action, state, res) => {
                    const contentType = res.headers.get('Content-Type');
                    let data = [];
                    if (contentType && ~contentType.indexOf('json')) {
                        await res.json().then((json) => {
                            data = json.data
                        });
                        return {
                            "code": 0,
                            "type": GOOGLE_REPLY_DETAIL_SUCCESS,
                            "data": data
                        }
                    }

                }
            },
            {
                type: GOOGLE_REPLY_DETAIL_FAILURE,
                payload: async (action, state, res) => {

                    let message = "";
                    await res.json().then((json) => {
                        message = json.message;
                    });

                    return {
                        "code": 1,
                        "type": GOOGLE_REPLY_DETAIL_FAILURE,
                        "message": message,
                        "data": [],
                    }
                }
            }
        ]
    }

});

export {GoogleReplyDetailCommentAction}